import moment from "moment";
export const generateCompleteDateRange = (apiData = [], fromDate, toDate,) => {
    if (!fromDate || !toDate) {
        if (!Array.isArray(apiData) || apiData.length === 0) {
            return [];
        }

        if (!fromDate || !toDate) {
            const to = moment().endOf("day");
            const from = moment().subtract(7, "days").startOf("day");
            fromDate = from;
            toDate = to;
        }

    }

    const from = moment(fromDate);
    const to = moment(toDate);
    const daysDiff = to.diff(from, "days");

    const dataMap = {};
    if (Array.isArray(apiData)) {
        apiData.forEach((item) => {
            const dateKey = moment(item.dates).format("YYYY-MM-DD");
            dataMap[dateKey] = item;
        });
    }

    const completeData = [];

    if (daysDiff <= 90) {
        let current = from.clone().startOf("day");
        while (current.isSameOrBefore(to, "day")) {
            const dateKey = current.format("YYYY-MM-DD");
            if (dataMap[dateKey]) {
                completeData.push(dataMap[dateKey]);
            } else {
                completeData.push({
                    dates: current.format("YYYY-MM-DD"),
                    channels: []
                });
            }

            current.add(1, "day");
        }
    } else {
        let current = from.clone().startOf("month");
        while (current.isSameOrBefore(to, "month")) {
            let monthData = null;
            apiData.forEach((item) => {
                const itemMonth = moment(item.dates).format("YYYY-MM");
                const currentMonth = current.format("YYYY-MM");
                if (itemMonth === currentMonth) {
                    monthData = item;
                }
            });

            if (monthData) {
                completeData.push(monthData);
            } else {
                completeData.push({
                    dates: current.format("YYYY-MM-01"),
                    channels: []
                });
            }

            current.add(1, "month");
        }
    }

    return completeData;
};

export const getDateLabel = (date, isYearMonthView) => {
    if (isYearMonthView) {
        return moment(date).format("MMM");
    }
    return moment(date).format("DD MMM");
};
